import { render, staticRenderFns } from "./invoiceNotPaid.vue?vue&type=template&id=0a1b83c2&"
import script from "./invoiceNotPaid.vue?vue&type=script&lang=js&"
export * from "./invoiceNotPaid.vue?vue&type=script&lang=js&"
import style0 from "./invoiceNotPaid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDataTable,VProgressCircular,VRow})
